module.exports = __webpack_public_path__ + "static/media/8.question_loop.c2fa7b3d.mp4";